import { render, staticRenderFns } from "./WebinarAssia.vue?vue&type=template&id=21b07464&scoped=true"
import script from "./WebinarAssia.vue?vue&type=script&lang=js"
export * from "./WebinarAssia.vue?vue&type=script&lang=js"
import style0 from "./WebinarAssia.vue?vue&type=style&index=0&id=21b07464&prod&scoped=true&lang=css"
import style1 from "./WebinarAssia.vue?vue&type=style&index=1&id=21b07464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b07464",
  null
  
)

export default component.exports